import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import { SET_CACHE, CLEAR_CACHE, FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_FAILURE } from './actionTypes';

export const setCache = (key, data) => ({
    type: SET_CACHE,
    payload: { key, data }
});

export const clearCache = () => ({
    type: CLEAR_CACHE
});

export const fetchUserRequest = (id) => ({
    type: FETCH_USER_REQUEST,
    payload: id,
});

export const fetchUserSuccess = (id, data) => ({
    type: FETCH_USER_SUCCESS,
    payload: { id, data },
});

export const fetchUserFailure = (id, error) => ({
    type: FETCH_USER_FAILURE,
    payload: { id, error },
});

export const fetchUserById = (id) => {
    return async (dispatch) => {
        dispatch(fetchUserRequest(id));
            try {
                const url = `${window.location.origin}/api/userinfo/${id}`;
                const response = await fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200,
                });
                const data = await response.json();
                if (data.error) {
                    if (data.error === 'Session Expired') {
                        let userAuthService = new UserAuthService();
                        userAuthService.logout();
                    } else {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    dispatch(fetchUserFailure(id, data.error));
                } else {
                    dispatch(fetchUserSuccess(id, data));
                    return data;
                }
            } catch (error) {
                dispatch(fetchUserFailure(id, error.toString()));
            }
        };
};